<template>
    <div class="form_block">
        <div class="form_block_header ">
            <div class="col-md-12">
                <h4 class="row justify-content-between">
                    <BCardTitle class="font-weight-bold col-md-12 pl-0  pb-0 mb-0" title-tag="h2">
                        {{ $t("two_factor_modal_title") }}
                    </BCardTitle>
                </h4>
            </div>
        </div>
        <BCol class="px-xl-2 " lg="12" md="12" sm="12" style="padding: 20px;">
            <validation-observer ref="registerValidation">
                <BForm @submit.prevent class="auth-login-form mt-2">
                    <template v-if="regForm">
                       <p class="pt-0 pb-1"> {{ $t("two_factor_modal_description") }}</p>
                        <!--select twofactor variant-->
                        <BFormGroup label-for="phone">
                            <validation-provider #default="{ errors }" class="d-flex" name="Phone">
                                <BFormRadio class="mr-3" name="some-radios" v-model="sendData.twoFactorType" value="email">
                                    E-Mail
                                </BFormRadio>
                                <BFormRadio name="some-radios" v-model="sendData.twoFactorType" value="phone">
                                    SMS
                                </BFormRadio>
                            </validation-provider>
                        </BFormGroup>

                        <BFormGroup
                            id="phoneGroup"
                            :label="$t('mobile') + ':'"
                            label-for="phone"
                            v-if="sendData.twoFactorType === 'phone'"
                        >
                            <BInputGroup>
                                <BInputGroupPrepend class="phoneCountries" id="phoneCountries">
                                    <b-form-select :options="phoneCountriesList" v-model="sendData.iso_code"/>
                                </BInputGroupPrepend>
                                <BFormInput
                                    id="phone"
                                    @input="checkPhoneFormatSignator(sendData.phone_email, sendData.iso_code)"
                                    class="form-control"
                                    v-model="sendData.phone_email"
                                />
                            </BInputGroup>
                            <span class="text-danger" v-if="phoneSignatorValidation">{{ phoneSignatorValidation }}</span>
                        </BFormGroup>

                        <!-- email -->
                        <BFormGroup :label="$t('email')" label-for="two_factor_email" v-if="sendData.twoFactorType === 'email'">
                            <validation-provider #default="{ errors }" name="two_factor_email" rules="email">
                                <BFormInput id="two_factor_email" placeholder="john@example.com" v-model.trim="sendData.phone_email"/>
                                <small class="text-danger">{{ $t(errors[0]) }}</small>
                            </validation-provider>
                        </BFormGroup>

                        <!-- submit buttons -->
                        <div class="d-flex justify-content-between align-items-center">
                            <BButton @click="sendCode" type="submit">
                                <img height="20" src="/new-loader.svg" v-if="resLoader" alt="Loader"/> {{ $t("send_code") }}
                            </BButton>
                            <BButton @click="skip" class="ml-2" variant="outline-dark">
                                {{ $t("skip") }} >>
                            </BButton>
                        </div>
                    </template>
                    <template v-else>
                        <BFormGroup :label="$t('code')" label-for="code">
                            <validation-provider #default="{ errors }" name="Email" rules="email">
                                <BFormInput id="code" placeholder="****" v-model.trim="code"/>
                            </validation-provider>
                        </BFormGroup>
                        <BButton @click="confirmCode" type="submit">
                            <img height="20" src="/new-loader.svg" v-if="resLoader1" alt="loader"/> {{ $t("confirm") }}
                        </BButton>
                        <BCardText class="text-center mt-2">
                            <BCardText @click="resend()" role="button" v-if="!resent">
                                <span>{{ $t("resend_code") }}</span>
                            </BCardText>
                            <BCardText v-else>
                                <span> {{ countdown }} {{ $t("resend_verification_code") }} </span>
                            </BCardText>
                        </BCardText>
                    </template>
                </BForm>
            </validation-observer>
        </BCol>
    </div>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {phone} from "phone";
import {email} from 'vee-validate/dist/rules';
import {
  BButton,
  BCardText,
  BCardTitle,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
} from "bootstrap-vue";

export default {
    name: "TwoFactor",
    components: {
      BCol, BFormGroup, BFormInput, BCardText, BCardTitle, BForm, BButton,
      BInputGroup, BFormSelect, ValidationProvider, ValidationObserver
    },
    data() {
      return {
        resLoader: false,
        resLoader1: false,
        regForm: true,
        code: null,
        sendData: {
          iso_code: null,
          phone_email: '',
          twoFactorType: "email"
        },
        disableInputs: false,
        role: null,
        resent: false,
        countdown: 60,
        phoneCountriesList: [],
        countries: [],
        phoneSignatorValidation: null
      }
    },

    created() {
      this.getTellCode()
      extend('email', {
        ...email,
        message: 'This field must be a valid email'
      });
    },

    methods: {
      sendCode() {
        this.resLoader = true;
        this.$http
            .post(`/twofactor/send-code`, this.sendData)
            .then((res) => {
              if (res) {
                this.resLoader = false;
                this.regForm = false;
              }
            });

        this.startCountdown();
      },

      skip() {
        this.$http.post(`/twofactor/close`)
            .then((res) => {
              if (res) {
                this.$emit('toggle-two-factor')
              }
            });
      },

      confirmCode() {
        this.resLoader1 = true;
        this.$http
            .post(`/twofactor/confirm-code`, {'code': this.code})
            .then((res) => {
              if (res) {
                this.resLoader1 = false;
                this.$emit('toggle-two-factor')
              }
            });
      },

      resend() {
        this.$http
            .post(`check-user-two-factor/${this.$store.state.auth.user.id}`, { "send_code": true })
            .then(() => {
              this.startCountdown();
            })

      },

      startCountdown() {
        this.resent = true;
        let timer = setInterval(() => {
          if (this.countdown > 0) {
            this.countdown--;
          } else {
            clearInterval(timer);
            this.resent = false;
            this.countdown = 60;
          }
        }, 1000);
      },

      getTellCode() {
        this.$http.post("/countries").then((res) => {
          res.data.value.map((item) => {
            this.phoneCountriesList.push({
              value: item.iso_code,
              text: `${item.iso_code} (${item.phone_code})`,
            });

            this.countries.push({
              value: item.id,
              text: item.name,
            });
          });
        });
      },

      checkPhoneFormatSignator(val, code) {
        if (val) {
          let validation = phone(val, {
            country: code,
            validateMobilePrefix: false
          });
          if (validation && !validation.isValid) {
            this.phoneSignatorValidation = `Phone for ${code} must be valid`;
          } else {
            this.phoneSignatorValidation = "";
          }
        }
      },
    }
  }
</script>

<style lang="scss">
    @import "@core/scss/vue/pages/page-auth.scss";

    .form_block {
        background-color: white;
        width: 100%;
        border-radius: 25px;
        overflow: hidden;
        height: fit-content;
    }

    .form_block .form_block_header {
        width: 100%;
        text-align: center;
        border-bottom: 1px solid #555;
        padding: 20px;
    }

    .form_block .form_block_header h2, .form_block .form_block_header span {
        color: #222f28;
    }

    .form_block input, .form_block select {
        background-color: #F7F6F4;
    }
</style>
